<div class="main-container">
  <ng-content select="mad-content-header"></ng-content>
  <ng-content select="mad-flowbar"></ng-content>
  <ng-content select="mad-content-panel-container"></ng-content>
</div>
